export const isProduction = (): boolean => {
  // ① Vercel builds & runtime  → import.meta.env.VERCEL_ENV
  // ② Local vite dev           → fallback to import.meta.env.MODE
  return (import.meta.env.VERCEL_ENV ?? import.meta.env.MODE) === "production";
};
